

<template>
  <div>

      <div class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li v-if="sumAlertActualChannel > 0">
                          <button  type="button" ><a class="h3 text-white">{{sumAlertActualChannel}}</a > <i class="h1 fa fa-bell fa-2x push-15-r "></i></button>
                      </li>


                      <li>
                          <button v-if="channelSharingEnableFlag" type="button" @click="shareEntity()" ><i class="h1 fa fa-share-alt fa-2x push-15-r "></i></button>
                      </li>

                      <li v-if="flagDisplayChannel===0">
                          <button type="button" @click="toggleDisplayChannel()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplayChannel">
                          <button  type="button" @click="toggleDisplayChannel()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="h3 block-title" @click="toggleDisplayChannel()"><i class="fa fa-television fa-1x push-5-r "></i>{{tempoBundle.channels[channelIndex].ReferenceName}}</h2>
            </div>



            <div v-if="flagDisplayChannel" class="block-content">
              <div class="row">
                <div class="col-xs-12">
                    <!-- Static Labels -->
                    
                      <div class="col-xs-12">
                        <div class="form-group">
                            <label class="col-xs-12">{{ textLabelRefrenceName[actualLanguage] }} (ID: {{channelIDLast4}})</label>
                            <div class="col-xs-12 col-sm-12 push">
                                <input v-model="tempoBundle.channels[channelIndex].ReferenceName" class="form-control"  placeholder="Entrez votre information">
                            </div>
                        </div>
                      </div>
                      

                      <div v-if="channelConfigViewFlag" class="col-xs-12 items-push">
                          <h4 class="h2"><i class="fa fa-gear push"></i> {{ sectionLabelDeviceConfig[actualLanguage] }}</h4>
                  
                          <div class=" col-xs-12 col-md-8 push">                           
                                <label class="h4 col-xs-12">{{ textLabelName[actualLanguage] }}</label>
                                <div class="col-xs-12 col-sm-12 push">
                                    <input v-model="tempoBundle.channels[channelIndex].ChannelData.channelInfo.channelName" class="h4 form-control" type="test" id="lock1-password" name="lock1-password" placeholder="Entrez votre information">
                                </div>

                                <label class="h4 col-xs-12">Description</label>
                                <div class="col-xs-12 col-sm-12">
                                    <input v-model="tempoBundle.channels[channelIndex].ChannelData.channelInfo.description" class="h4 form-control" type="test" id="lock1-password" name="lock1-password" placeholder="Entrez votre information">
                                </div>
                          </div>

                          <div class="col-xs-12 col-md-4">
                            <div class="form-group appliance-list-wrap">
                              <p><img @click="showApplianceList = !showApplianceList" width="100px" :src="`appliances/${tempoBundle.channels[channelIndex].ChannelData.channelInfo.iconFile}` | s3Image"></p>
                              <button @click="showApplianceList = !showApplianceList" type="button" class="btn btn-big btn-primary btn-rounded" name="button"><i class='fa fa-pencil'></i></button>
                              <appliance-list @onSelect="onApplianceSelect" class="appliance-list" v-if="showApplianceList"></appliance-list>
                            </div>
                          </div>
                    </div>



                    <div v-if="channelConfigEditFlag" class="col-xs-12">
                      <div v-if="displayDevicePortConfig" class="col-xs-12 col-md-6">
                            <div class="form-group">
                              <label class="col-xs-12" for="example-select">{{ selectLabelLinkedModule[actualLanguage] }}</label>
                              <div class="col-xs-12 col-sm-9">
                                  <select class="form-control" @click="validateIfChannelDeviceInDeviceList()" v-model=tempoBundle.channels[channelIndex].ChannelData.linkedDevicePorts.deviceId  size="1">
                                      <option value="Aucun/None">Aucun/None</option>
                                      <option v-for="device in tempoBundle.devices" :value="device.DeviceData.deviceId">{{device.ReferenceName}}</option>
                                  </select>
                              </div>
                          </div>
                      </div>
                      <div v-else class="col-xs-12">
                          <div class="col-xs-12 col-md-12 align-center push">
                                <h6 >{{messageLinkedModuleNotInSystem[actualLanguage]}}</h6>
                                <button type="button" @click="displayDevicePortConfig = true" class="btn btn-xs" name="buttonAddPlanItem">{{messageModifyForModuleInSystem[actualLanguage]}}</button>
                          </div>
                      </div>

                      
                      
                      <div v-if="thisChannelDeviceIndex >= 0" >
                        <div v-if="displayDevicePortConfig & thisChannelDeviceIndex >= 0 & tempoBundle.devices[thisChannelDeviceIndex].DeviceData.frontendComponents.componentChannelConfig=='EVA_V1P00'" class="col-xs-12 col-md-6">

                            <label class="col-xs-12" for="example-multiple-select">{{ selectLabelLinkedPort[actualLanguage] }}</label>
                            <div class="col-xs-12 col-sm-12">
                                <select class="form-control" v-model=tempoBundle.channels[channelIndex].ChannelData.linkedDevicePorts.ports size="4" multiple>
                                    <option value="1">Port 1</option>
                                    <option value="2">Port 2</option>
                                    <option value="3">Port 3</option>
                                    <option value="4">Port 4</option>
                                    <option value="5">Port 5</option>
                                    <option value="6">Port 6</option>
                                </select>
                            </div>
                            <label class="col-xs-12 push" for="example-multiple-select">{{ textSelectMultiplePort[actualLanguage] }}</label>



                            <div class="col-xs-12 col-sm-12">
                              <div class="block block-bordered block-content">
                                <div class="row">
                                  <div class="col-xs-12 col-sm-12 align-center push">
                                  <h4 class="h2">{{ titleLivePanel[actualLanguage] }}</h4>
                                  </div>
                                  <span>
                                  <div v-if="actualBundle.bundleRights.realTimeMeasurementPanel" class="col-xs-12 col-sm-9">
                                    <h5 class="h4 font-w200 text-center">{{addThisChannelToLivePanel[actualLanguage]}}</h5>
                                  </div>
                                  <div v-if="actualBundle.bundleRights.realTimeMeasurementPanel" class="col-xs-12 col-sm-3 push">
                                    <label class="css-input switch switch-success">
                                        <input type="checkbox" checked v-model="tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.enabled"><span></span>
                                    </label>
                                  </div>
                                  <div v-else class="col-xs-12">
                                      <h6 class="h4 font-w200 text-center push">{{realTimeMeasurementPanelNotAvailable[actualLanguage]}}</h6>
                                  </div>



                                  </span>
                                  <span v-if="actualBundle.bundleRights.realTimeMeasurementPanel">
                                    <div v-if ="tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.enabled" class="form-group">
                                        <label class="h4 col-xs-12 col-sm-9">{{warningLevelLivePanel[actualLanguage]}}</label>
                                        <div class="col-xs-12 col-sm-3">
                                            <input v-model="tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.powerWarningLevel" class="form-control align-center" type="test" id="lock1-password" name="lock1-password" placeholder="Entrez votre information">
                                        </div>
                                    </div>
                                    <div v-if ="tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.enabled" class="form-group">
                                        <label class="h4 col-xs-12 col-sm-9">{{limitLevelLivePanel[actualLanguage]}}</label>
                                        <div class="col-xs-12 col-sm-3 ">
                                            <input v-model="tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.powerLimitLevel" class="form-control align-center" type="test" id="lock1-password" name="lock1-password" placeholder="Entrez votre information">
                                        </div>
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>

                        </div>
                      </div>


                    </div>
                    <!-- END channelConfigEditFlag -->


                    <div v-if="actualBundle.channelsAttributes.length > 0 & false" class="col-xs-12" >
                        <h4 class="h2"><i class="fa fa-tags"></i> {{ sectionLabelDeviceTags[actualLanguage] }}</h4>
                        <div v-for = "(categoryList ,index) in actualBundle.channelsAttributes">
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="col-xs-12" for="example-select">{{categoryList.title}}</label>
                                      <div class="col-xs-12 col-sm-12">
                                          <select class="form-control" v-model="tempoBundle.channels[channelIndex].Attributes[index]" id="example-select" name="example-select" size="1">
                                              <option v-for= "(element, index2) in categoryList.data" :value="element">{{element}}</option>
                                          </select>
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12 items-push" >
                      <div  class="col-xs-12 col-md-6">
                        <button v-if="channelConfigDeleteFlag" type="button" style="color:white" @click="confirmRemoveChannel()" class="h4 btn btn-danger" name="buttonDeletePlanItem2">
                          <spinner size="small" v-if="channelIsDeleting"></spinner>
                          <span v-else><i class="fa fa-trash fa-1x push-5-r "></i>{{ buttonLabelDeleteDevice[actualLanguage] }}</span></button>
                      </div>

                      <div  class="col-xs-12 col-md-6">
                        <p><button v-if="channelConfigEditFlag" @click="saveChannelModifications()" type="button" class="h4 btn btn-success align-right" name="button">
                          <spinner size="small" v-if="channelIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ buttonLabelSaveDevice[actualLanguage] }}</span></button></p>
                      </div>
                    </div>




                    <!-- Alert COnfig -->
                   <div v-if="tempoBundle.channels[channelIndex].ChannelData.linkedDevicePorts.deviceId !='TBD' & channelConfigEditFlag & tempoBundle.channels[channelIndex].ChannelData.linkedDevicePorts.deviceId !='Aucun/None'" class="col-xs-12">
                      <div class="col-xs-12 push">
                        <h4 class="h2"><i class="fa fa-bell"></i> {{ sectionLabelDeviceAlert[actualLanguage] }}</h4>
                      </div>

                      <div v-for="(alert,index) in actualBundle.alerts" class="col-xs-12">
                        <div v-if="alert.AlertData.linked_channel[0]===tempoBundle.channels[channelIndex].ChannelData.channelId" class="block-content">
                          <config-alert :alertIndex="index" ></config-alert>
                        </div>
                      </div>


                      <div class="col-xs-12">
                        <div class="form-group" v-if="alertShowAddButton">
                          <div v-if="flagDisplayAlertConfig" class="col-xs-12 col-md-12">
                            <button v-if="channelConfigEditFlag" type="button" @click="openAlertAddMenu()" class="h4 btn btn-success" name="buttonAddPlanItem"><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-bell fa-1x push-5-r "></i>{{ labelFieldButtonAddAlert[actualLanguage] }}</button>
                          </div>
                          <div v-else class="col-xs-12 col-md-12">
                            <h5 class="h4"><i class="fa fa-exclamation-triangle"></i> {{labelUserMustSubscribeToConfigAlert[actualLanguage]}}</h5>
                          </div>                          
                        </div>                      
                      
                        

                          <div v-else class="col-xs-12 col-md-12">
                            <div class="block block-bordered">
                                <div class="block-header bg-gray-lighter">
                                    <ul class="block-options">
                                        <li>
                                            <button type="button" @click="alertShowAddButton=true"><i class="si si-plus"></i></button>
                                        </li>
                                    </ul>
                                    <h3 class="block-title">{{ labelFieldButtonAddAlert[actualLanguage] }} {{tempoBundle.channels[channelIndex].ReferenceName}}</h3>
                                </div>

                                <div class="block-content">
                                  <div class="col-xs-6 col-md-6">
                                    <label>{{labelAlertSelect[actualLanguage]}}</label>
                                    <select v-model="alertToAddIndex" class="js-select2">
                                      <option v-for="(alert, index) in alertsDefinitions" v-bind:value=index>{{ alert.alertTitle[actualLanguage]}}</option>
                                    </select>
                                  </div>

                                  <p><img class = "img-responsive" width="600px" :src="`alerts/${alertsDefinitions[alertToAddIndex].icon[actualLanguage]}` | s3Image"></p>

                                  <div v-if="alertsDefinitions[alertToAddIndex].alertDescription" class="col-xs-12 col-md-12 push">
                                    <h6>{{alertsDefinitions[alertToAddIndex].alertDescription[actualLanguage]}}</h6>
                                  </div>

                                  <div class="col-xs-12 col-md-12">
                                    
                                    
                                      <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th class="text-center" style="width: 75%;">{{ tableTitleAlertParameter[actualLanguage] }}</th>
                                                    <th class="text-center" style="width: 25%;">{{ tableTitleAlertParameterValue[actualLanguage] }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                              <tr v-for="(parameter,index) in alertsDefinitions[alertToAddIndex].parameters">
                                                  <td class="text-center">{{parameter.parameterTitle[actualLanguage]}}</td>
                                                  <td v-if="parameter.dataType==='Numeric'">
                                                    <input v-model="parameter.value" class="form-control text-center" type="test" id="lock1-password" name="lock1-password" placeholder="Entrez votre information">
                                                  </td>


                                                  <td v-if="parameter.dataType==='Boolean'">
                                                    <label class="css-input switch switch-success">
                                                      <input type="checkbox" checked v-model="parameter.value"><span></span>
                                                    </label>
                                                  </td>

                                                  <td v-if="parameter.dataType==='DateMonth'">
                                                    <select v-model="parameter.value" class="form-control" size="1">
                                                              <option v-for="month in monthOptions" v-bind:value=month.value>{{ month.text }}</option>
                                                    </select>
                                                  </td>

                                                  <td v-if="parameter.dataType==='DateDay'">
                                                    <select v-model="parameter.value" class="form-control" size="1">
                                                              <option v-for="day in dayOptions" v-bind:value=day.value>{{ day.text }}</option>
                                                    </select>
                                                  </td>

                                                  <td v-if="parameter.dataType==='DateHour'">
                                                    <select v-model="parameter.value" class="form-control" size="1">
                                                              <option v-for="hour in hourOptions" v-bind:value=hour.value>{{ hour.text }}</option>
                                                    </select>
                                                  </td>
                                              </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    

                                  </div>


                                  <button  type="button" @click="addAlertLine" class="h4 btn btn-success" name="buttonAddPlanItem">
                                    <spinner size="small" v-if="alertIsCreating"></spinner>
                                    <span v-else><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelFieldButtonConfirmAddAlert[actualLanguage] }}</span></button>
                                  <button type="button" @click="alertShowAddButton=true" class="h4 btn btn-danger" name="buttonAddPlanItem"><i class="fa fa-close fa-1x push-5-r "></i>{{ labelFieldButtonCancelAddAlert[actualLanguage] }}</button>
                                  
                                </div>
                            </div>
                          </div>

                        
                      </div>
                    </div>
                    <!-- END Alert COnfig -->







                    
                </div>
                <!-- END channelConfigViewFlag -->
              </div>
            </div>
        </div>
      </div>
      </div>
    </div>
  </div>


</template>

<script>


import _ from 'underscore'
import {mapState, mapGetters,mapActions} from 'vuex'
import ApplianceList from '@/views/configuration/ApplianceList'
import ConfigAlert from './ConfigAlert'
import alertDef from '@/views/configuration/AlertDefinition.js'
import Spinner from '../../components/Spinner.vue'


export default {
  props: ['channelIndex'],
  components: {
    ApplianceList,
    ConfigAlert,
    Spinner,
  },
  data() {
    return {
      tempoBundle : {},
      displayDataTable : false,
      showApplianceList : false,
      flagDisplayChannel : 0,
      //alertsDefinitions : alertDef,
      alertsDefinitions : [],
      alertShowAddButton: true,
      channelIsSaving : false,
      channelIsDeleting : false,
      flagDisplayAlertConfig : false,
      alertIsCreating : false,
      channelIDLast4 : 'AAAA',

      alertToAddIndex : 0,
      sumAlertActualBundle : 0,
      sumAlertActualChannel : 0,
      thisChannelDeviceIndex : -1,
      
      center: {lat: 46, lng: 71},
      markers: [],
      place: null,
      locationString : '',

      labelAlertSelect:{FR: "Sélectionner le type d'alerte à ajouter:", EN: 'Select type of alert to add:'},
      labelFieldButtonAddAlert: {FR: "Ajouter une alerte à l'appareil", EN: 'Add device alert'},
      labelUserMustSubscribeToConfigAlert: {FR: "Pour accéder aux alertes, vous devez adhérer a un forfait incluant ce service. Vous pouvez adhérer à un forfait dans  la section MON PLAN DE SERVICE dans le menu MON PROFILE.",
                                 EN: 'To access alerts, you must subscribe to a package that includes this service. You can subscribe to a monitoring package in the MY SERVICE PLAN section in the MY PROFILE menu.'},
      labelFieldButtonConfirmAddAlert: {FR: 'Ajouter', EN: 'Add'},
      labelFieldButtonCancelAddAlert: {FR: 'Annuler', EN: 'Cancel'},     
      actualLanguage : "FR",
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},
      messageLinkedModuleNotInSystem: {FR: "Le module lié à cet appareil ne fait pas partie de ce système.", EN: 'The module linked to this device is not in this system.'},
      messageModifyForModuleInSystem: {FR: "Modifier pour un module de ce système", EN: 'Modify for a module in this system'},

      textLabelRefrenceName: {FR: "Nom de référence", EN: 'Referencen name'},
      sectionLabelDeviceConfig: {FR: "Configuration de l'appareil", EN: 'Device configuration'},
      textLabelName: {FR: "Nom de l'appareil", EN: 'Device name'},
      selectLabelLinkedModule: {FR: "Module de mesure lié", EN: 'Linked monitoring module'},
      selectLabelLinkedPort: {FR: "Port(s) du module lié(s)", EN: 'Monitoring linked port(s)'},
      textSelectMultiplePort: {FR: "(Appuyer sur CTRL pour sélectionner plusieurs ports)", EN: '(Press CTRL button to select multiple ports)'},

      titleLivePanel: {FR: "Mesure temps réel", EN: 'Real time measurement'},
      addThisChannelToLivePanel: {FR: "Ajouter cet appareil à la section Mesure temps réel", EN: 'Add this device to Real time measurement panel'},
      warningLevelLivePanel: {FR: " Puissance avertissement (jaune) :", EN: ' Warning power level (yellow) :'},
      limitLevelLivePanel: {FR: " Puissance limite (rouge) :", EN: ' Limit power level (red) :'},
      realTimeMeasurementPanelNotAvailable: {FR: "Mesure temps réel non disponible. Pour activer cette option vous devez contacter support@evsens.ca.",
                                            EN: 'Real-time measurement not available. To activate this option you must contact support@evsens.ca.'},

      sectionChannelLocation:{FR: "Localisation de l'appareil", EN: 'Device location'},
      labelFieldChannelAddress:{FR: "Adresse", EN: 'Address'},

      sectionLabelDeviceTags :{FR: "Étiquettes de l'appareil", EN: 'Device tags'},
      buttonLabelDeleteDevice:{FR: "Supprimer cet appareil", EN: 'Delete this device'},
      buttonLabelSaveDevice:{FR: "Enregistrer les paramètres", EN: 'Save parameters'},
      sectionLabelDeviceAlert:{FR: "Alertes de l'appareil mesuré", EN: "Monitored device alerts"},
      tableTitleAlertParameter:{FR: "Paramètre(s) de l'alerte", EN: 'Alert parameter(s)'},
      tableTitleAlertParameterValue:{FR: "Valeur", EN: 'Value'},
      channelSaveMessage:{FR: "Attention, si le nom de référence a été modifié, il est possible que la position dans la liste soit modifiée!",
                           EN: 'Attention, if the reference name changed, it is possible that the device position in the list change!'},

      messageRemoveConfirmA:{FR: "Confirmer la supression de l'appareil : ", EN: 'Confirm device deletion : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},
      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},
      messageHigherPlanRequired:{FR: "Ce type d'alerte requiert un plan plus élevé. Vous devez souscrire à un nouveau plan pour y avoir accèes.", EN: 'This alert type requires higher plan. You need to subscribe to higher plan to have acsess.'},
      messageAlertLimitReach:{FR: "Vous avez atteint la limite d'alerte de votre profile", EN: 'You reach the alert limit of your profile.'},
      messageAlertLimitDeviceReach:{FR: "Vous avez atteint la limite d'alerte pour cet appareil", EN: 'You reach the alert limit for this device'},
      messageReferenceNamePrompt:{FR: "Nom de référence pour cette alerte", EN: 'Alert reference name'},
      messageReferenceNamePromptTextBox:{FR: "Alerte", EN: 'Alert'},

      channelConfigViewFlag : false,
      channelConfigEditFlag : false,
      channelConfigDeleteFlag : false,
      channelSharingEnableFlag : false,
      displayDevicePortConfig : false,
      valBidon: false,
      puissanceAvertissement : 0,
      puissanceLimit : 0,

      monthOptions:[{text:'01-Jan', value:'1'},{text:'02-Fév/Feb', value:'2'},{text:'03-Mar', value:'3'},
                    {text:'04-Avr/Apr', value:'4'},{text:'05-Mai/May', value:'5'},{text:'06-Jui/Jun', value:'6'},
                    {text:'07-Jui/Jul', value:'7'},{text:'08-Aoû/Aug', value:'8'},{text:'09-Sept', value:'9'},
                    {text:'10-Oct', value:'10'},{text:'11-Nov', value:'11'},{text:'12-Déc/Dec', value:'12'}],

      dayOptions:[{text:'Lun/Mon', value:'1'},{text:'Mar/Tue', value:'2'},{text:'Mer/Wed', value:'3'},
                    {text:'Jeu/Thu', value:'4'},{text:'Ven/Fri', value:'5'},{text:'Sam/Sat', value:'6'},
                    {text:'Dim/Sun', value:'7'}],

      hourOptions:[{text:'00:00', value:'0'},{text:'01:00', value:'1'},{text:'02:00', value:'2'},{text:'03:00', value:3},{text:'04:00', value:'4'},
                  {text:'05:00', value:'5'},{text:'06:00', value:'6'},{text:'07:00', value:'7'},{text:'08:00', value:8},{text:'09:00', value:'9'},
                  {text:'10:00', value:'10'},{text:'11:00', value:'11'},{text:'12:00', value:'12'},{text:'13:00', value:13},{text:'14:00', value:'14'},
                  {text:'15:00', value:'15'},{text:'16:00', value:'16'},{text:'17:00', value:'17'},{text:'18:00', value:18},{text:'19:00', value:'19'},
                  {text:'20:00', value:'20'},{text:'21:00', value:'21'},{text:'22:00', value:'22'},{text:'23:00', value:23},{text:'24:00', value:'24'}],



    }
  },


  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle','parentContainer']),
    ...mapState('overlayStore', ['overlayParameters']),
  },
  watch: {
    actualBundle(){
        this.reloadTempoBundle()
    },
  },

  methods: {
  ...mapActions('overlayStore', ['showModal']),

   toggleDisplayChannel(){
      this.flagDisplayChannel = ~this.flagDisplayChannel
    },

    usePlace(place) {
      let newLat = place.geometry.location.lat()
      let newLng = place.geometry.location.lng()
      this.center = {lat: newLat, lng: newLng}
      this.place = place
      this.locationString = place.formatted_address
      this.markers= [{
        position: {
          lat: newLat,
          lng: newLng,
        }
      }]
      
      this.tempoBundle.channels[this.channelIndex].ChannelData.position.latitude  = newLat
      this.tempoBundle.channels[this.channelIndex].ChannelData.position.longitude = newLng
      this.tempoBundle.channels[this.channelIndex].ChannelData.address = place.formatted_address
      //console.log(this.tempoBundle.channels[this.channelIndex].ChannelData)
      this.place = null;
    },

    reloadTempoBundle(){
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
    },


    onApplianceSelect(a) {
      this.showApplianceList = false
      //console.log(a)
      //this.portModel.portName = a.name
      //this.portModel.voltage  = a.voltage
      this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.iconFile = a.iconFile
      this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.channelType = a.applianceType
      if (this.actualLanguage == "FR"){
        this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.channelName = a.name
        }
        else{
          this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.channelName = a.name_EN
        }
    },

    saveChannelModifications() {
        this.channelIsSaving = true
        var requestData = { 'postAction':'SaveChannelModification',
                            'bundleId': this.tempoBundle.bundle_id,
                            'channelIndex': this.tempoBundle.channels[this.channelIndex].ChannelBundleIndex,
                            'channelData':this.tempoBundle.channels[this.channelIndex],
                            'parentContainer':this.parentContainer,
                            }
                            //console.log(requestData)
        this.$store.dispatch('sessionStore/postChannel', requestData)
            .then((response) => {
              //console.log(response.data)
              this.channelIsSaving = false
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                window.alert(this.channelSaveMessage[this.actualLanguage] )
                this.$store.dispatch('sessionStore/reloadActualBundle')
                this.alertShowAddButton=true
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage] )}
            })       
      
    },

    confirmRemoveChannel(){
          var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.tempoBundle.channels[this.channelIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

          if(confirmation=='DELETE'){
              this.channelIsDeleting = true
              var requestData = { 'postAction':'RemoveChannelFromBundle',
                                  'channelIndex':this.tempoBundle.channels[this.channelIndex].ChannelBundleIndex,
                                  'bundleId': this.tempoBundle.bundle_id,
                                  'channelData': {'channelId':this.tempoBundle.channels[this.channelIndex].ChannelData.channelId},
                                  'bundleData':{'bundleId':this.actualBundle.bundle_id},
                                  'parentContainer':this.parentContainer,
                                  }
              this.$store.dispatch('sessionStore/postBundle', requestData)
                  .then((response) => {
                    //console.log(response.data)
                    this.channelIsDeleting = false
                  if(response.data.Code=='OK'){
                      //this.$store.dispatch('sessionStore/getGroupArborescence')
                      this.$store.dispatch('sessionStore/reloadActualBundle')
                      this.alertShowAddButton=true
                      }
                      else{ window.alert(response.data.PromptMessage[this.actualLanguage] )}
                  })       
          }

    },


    openAlertAddMenu(){
      var requestData = { 'postAction':'GetAlertsDefinitions'}
      this.$store.dispatch('sessionStore/postAlert', requestData)
          .then((response) => {
            this.alertIsCreating = false
            //console.log('---Reponse Get Alert Def-----')
            //console.log(response.data)
          if(response.data.Code=='OK'){
              this.alertsDefinitions = response.data.AlertsDefinitions
              this.alertShowAddButton=false
              }
          }) 
    },


    addAlertLine(){
      this.alertsDefinitions[this.alertToAddIndex].alertId= moment().format('YYYY-MM-DD')+'T'+moment().format('HH:mm:ss')
      this.alertsDefinitions[this.alertToAddIndex].emailRecipient[0] = this.profileData.profileInfo.email
      this.alertsDefinitions[this.alertToAddIndex].usersRecipient[0].email = this.profileData.profileInfo.email
      this.alertsDefinitions[this.alertToAddIndex].usersRecipient[0].profileId = this.profileData.profileId
      
      var tempo = jQuery.extend(true,{},this.alertsDefinitions[this.alertToAddIndex])
      tempo['alert_linked_bundle']=this.actualBundle.bundle_id
      tempo['linked_channel']=this.actualBundle.channels[this.channelIndex].ChannelData.channelId
      //console.log('------------------Alert tempo-----')
      //console.log(tempo)

      var alertReferenceName = prompt(this.messageReferenceNamePrompt[this.actualLanguage], this.messageReferenceNamePromptTextBox[this.actualLanguage]);

      if(alertReferenceName != null){
          this.alertIsCreating = true
          var requestData = { 'postAction':'AddNewAlert',
                              'referenceName':alertReferenceName,
                              'bundleData':{'bundleId':this.actualBundle.bundle_id},
                              'alertData':tempo}
          this.$store.dispatch('sessionStore/postAlert', requestData)
              .then((response) => {
                this.alertIsCreating = false
                //console.log(response.data)
              if(response.data.Code=='OK'){
                  //this.$store.dispatch('sessionStore/getGroupArborescence')
                  this.$store.dispatch('sessionStore/reloadActualBundle')
                  this.sumAlertActualChannel +=1
                  this.alertShowAddButton=true
                  }
                  else{ window.alert(response.data.PromptMessage[this.actualLanguage] )}
              })
      }

      
    },


  /*
    computeSumBundleAlert() {
      this.sumAlertActualBundle = this.actualBundle.alerts.length

    },
*/
    computeSumChannelAlert(){
      this.sumAlertActualChannel = 0
      for(var n=0;n<this.actualBundle.alerts.length;n++){
            if(this.actualBundle.alerts[n].AlertData.linked_channel[0]==this.tempoBundle.channels[this.channelIndex].ChannelData.channelId){
              this.sumAlertActualChannel++
            }
        }
    },
    



    shareEntity(){
      var modalParameters = {'modalTitle':{FR: "Partage de mesure d'appareils", EN: 'Device monitoring sharing'},
                        'entityOwner':this.actualBundle.bundle_id,
                        'sharingType':'Channel',
                        'entityId':this.tempoBundle.channels[this.channelIndex].ChannelData.channelId,
                        'entityReferenceName':this.tempoBundle.channels[this.channelIndex].ReferenceName,
                        'displayAlertOptions':false,
                        'displayChannelOptions':true,
                        'displayDeviceOptions':false,
                        'displayBundleOptions':false,
                        'displayGroupOptions':false,
                        'displayUserOptions':false}

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('config-access-rules-form')
    },


    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value
          //console.log('Value Found')
          }
        }
        return value
    },

    validateIfChannelDeviceInDeviceList(){
      var returnValue = false
      this.thisChannelDeviceIndex = -1
      for (var n = 0; n < this.tempoBundle.devices.length; n++){
        if(this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId == this.tempoBundle.devices[n].DeviceData.deviceId){
          returnValue = true
          this.thisChannelDeviceIndex = n
        }
      }

      if(this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId=='TBD'){
        returnValue = true
      }

      if(this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId=='Aucun/None'){
        returnValue = true
      }

      return returnValue
    },


  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;

    this.computeSumChannelAlert()

    //console.log(this.tempoBundle.channels[this.channelIndex].ChannelData)
    //console.log(this.thisChannelDeviceIndex)


    let LengthChannelId = this.tempoBundle.channels[this.channelIndex].ChannelData.channelId.length

    this.channelIDLast4 = this.tempoBundle.channels[this.channelIndex].ChannelData.channelId.substring(LengthChannelId-4,LengthChannelId)


    this.channelConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.channels[this.channelIndex].ChannelData.permissions,'channelConfigView')
    this.channelConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.permissions.channel,'channelConfigEdit')
    this.channelConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.permissions.channel,'channelConfigDelete')
    this.channelSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.channels[this.channelIndex].ChannelData.permissions,'channelSharingEnable')

    this.displayDevicePortConfig = this.validateIfChannelDeviceInDeviceList()
    
    this.locationString = this.tempoBundle.channels[this.channelIndex].ChannelData.address
    this.markers = [{
        position: {
          lat: this.tempoBundle.channels[this.channelIndex].ChannelData.position.latitude,
          lng: this.tempoBundle.channels[this.channelIndex].ChannelData.position.longitude,
        }
      }]
    this.center = {lat: this.tempoBundle.channels[this.channelIndex].ChannelData.position.latitude,
                   lng: this.tempoBundle.channels[this.channelIndex].ChannelData.position.longitude}


    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}

    if(parseInt(this.tempoBundle.bundleRights.alertLimitPerBundle.max) > 0){
      this.flagDisplayAlertConfig = true
    }

  },


  beforeMount(){
    this.reloadTempoBundle()
  }

}
</script>

<style lang="css">
  .h1 {font-size: 24px;}
  .h2 {font-size: 20px;}
  .h3 {font-size: 16px;}
  .h4 {font-size: 14px;}
  .h5 {font-size: 12px;}

  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 600px) {
      .h1 {font-size: 18px;}
      .h2 {font-size: 16px;}
      .h3 {font-size: 14px;}
      .h4 {font-size: 10px;}
      .h5 {font-size: 8px;}
  }

</style>



// WEBPACK FOOTER //
// ConfigChannel.vue?33c192e0